import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const blockWrapper = css`
  padding: 20px;
  border-radius: 5px;
  border: 1px solid ${colors.gray.light};

  > span {
    color: ${colors.gray.dark};
  }
`;

export default blockWrapper;
